import type { FluentIcon, FluentIconsProps } from '@fluentui/react-icons';

const VIEW_BOX = '0 0 24 24';

// Person silhouette: head circle r=3.5 at (9, 11), torso half-disc.
const HEAD_CX = 9;
const HEAD_CY = 11;
const HEAD_R = 3.5;
const HEAD_RIGHT_X = HEAD_CX + HEAD_R; // 12.5

const BODY_REGULAR_PATH = 'M2 22 C2 18.13 5.13 15 9 15 S16 18.13 16 22';
const BODY_FILLED_PATH = 'M2 22 C2 18.13 5.13 15 9 15 S16 18.13 16 22 Z';

// 6-toothed gear placed to the right of the head, larger than before.
// Center (17, 7), outer R=5, inner R=3. 12 vertices alternating outer/inner.
// Gear left-most outer point x = cx - outerR*sin(60°) = 17 - 4.33 = 12.67 — sits just outside head's right edge (12.5).
const GEAR_CX = 17;
const GEAR_CY = 7;
const GEAR_LEFT_X = 12.67;
const GEAR_BOTTOM_Y = 12;

const GEAR_PATH =
  'M17 2L18.5 4.4L21.33 4.5L20 7L21.33 9.5L18.5 9.6L17 12L15.5 9.6L12.67 9.5L14 7L12.67 4.5L15.5 4.4Z';
const GEAR_HOLE_CR = 1.6;

export const AdminPersonaIcon24Regular: FluentIcon = ((props: FluentIconsProps) => (
  <svg
    width="24"
    height="24"
    {...props}
    viewBox={VIEW_BOX}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinejoin="round"
    strokeLinecap="round"
  >
    <g data-part="person">
      <circle
        data-part="person-head"
        data-right-x={HEAD_RIGHT_X}
        cx={HEAD_CX}
        cy={HEAD_CY}
        r={HEAD_R}
      />
      <path d={BODY_REGULAR_PATH} />
    </g>
    <g
      data-part="gear"
      data-cx={GEAR_CX}
      data-cy={GEAR_CY}
      data-left-x={GEAR_LEFT_X}
      data-bottom-y={GEAR_BOTTOM_Y}
    >
      <path d={GEAR_PATH} />
      <circle cx={GEAR_CX} cy={GEAR_CY} r={GEAR_HOLE_CR} />
    </g>
  </svg>
)) as FluentIcon;
AdminPersonaIcon24Regular.displayName = 'AdminPersonaIcon24Regular';

export const AdminPersonaIcon24Filled: FluentIcon = ((props: FluentIconsProps) => (
  <svg width="24" height="24" {...props} viewBox={VIEW_BOX} fill="currentColor" fillRule="evenodd">
    <g data-part="person">
      <circle
        data-part="person-head"
        data-right-x={HEAD_RIGHT_X}
        cx={HEAD_CX}
        cy={HEAD_CY}
        r={HEAD_R}
      />
      <path d={BODY_FILLED_PATH} />
    </g>
    <g
      data-part="gear"
      data-cx={GEAR_CX}
      data-cy={GEAR_CY}
      data-left-x={GEAR_LEFT_X}
      data-bottom-y={GEAR_BOTTOM_Y}
    >
      <path
        d={`${GEAR_PATH} M${GEAR_CX + GEAR_HOLE_CR} ${GEAR_CY}a${GEAR_HOLE_CR} ${GEAR_HOLE_CR} 0 1 1-${GEAR_HOLE_CR * 2} 0 ${GEAR_HOLE_CR} ${GEAR_HOLE_CR} 0 1 1 ${GEAR_HOLE_CR * 2} 0Z`}
      />
    </g>
  </svg>
)) as FluentIcon;
AdminPersonaIcon24Filled.displayName = 'AdminPersonaIcon24Filled';
